import React from 'react';
import T from 'prop-types';
import { mapValues, pickBy } from 'lodash-es';

import { SmartChart } from '../../../../../components/Chart';
import Skeleton from '../../../../../components/Skeleton';
import { columnChartConfig } from './config';
import { basePartialFilters } from '../../../configs/chart-config';

const GrowthChart = ({ metricOption, series, isPending }) => {
  const metricSeries = pickBy(series, (_, key) => key === `${metricOption.value}_change`);

  const metaSeries = mapValues(metricSeries, () => ({
    name: metricOption.label,
    color: '#348BE3',
    visible: true,
    type: 'column',
  }));

  const chartConfig = columnChartConfig({
    series: metricSeries,
  });

  return (
    <div className="growth-chart">
      <p className="eyebrow">Year-over-year growth</p>
      {isPending ? (
        <Skeleton height={234} className="d-flex" />
      ) : (
        <SmartChart
          chartId="market-growth-chart"
          series={metricSeries}
          metaSeriesData={metaSeries}
          config={chartConfig}
          allowPartialPeriods
          filters={basePartialFilters}
        />
      )}
    </div>
  );
};

GrowthChart.propTypes = {
  metricOption: T.shape({
    value: T.string,
    label: T.string,
  }).isRequired,
  series: T.object,
  isPending: T.bool,
};

export default GrowthChart;
